import React, { useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import { useDebounce } from 'use-debounce'

import { CustomersListFilterInput } from '@app/graphql/types'
import { useIntl } from '@app/intl/Intl'
import { InputField } from '@app/lib/fields/InputField/InputField'
import { TextInput } from '@app/lib/inputs/TextInput/TextInput'

export type KeywordSearchInputProps = {
  values: CustomersListFilterInput
  onSubmit: (values: CustomersListFilterInput) => void
}

type FormData = {
  keyword: string
}

export const CustomerKeywordFilterForm = ({ values, onSubmit }: KeywordSearchInputProps) => {
  const { formatMessage } = useIntl()

  const methods = useForm<FormData>({
    defaultValues: {
      keyword: values.keyword?.equals || ''
    }
  })

  const [keyword] = methods.watch(['keyword'])
  const [debouncedValue] = useDebounce(keyword, 500)

  useEffect(() => {
    onSubmit({
      keyword: debouncedValue ? { equals: debouncedValue } : undefined
    })
  }, [debouncedValue])

  return (
    <FormProvider {...methods}>
      <form>
        <InputField
          name='keyword'
          render={({ inputProps }) => {
            return (
              <TextInput
                placeholder={formatMessage({ id: 'Lawyer.CustomerList.KeywordFilter.Placeholder' })}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault()
                    e.stopPropagation()
                  }
                }}
                {...inputProps}
              />
            )
          }}
        />
      </form>
    </FormProvider>
  )
}
